module.exports = __webpack_public_path__ + "img/terminal_lite-1.d1eee2b8.jpg";